const SESSION_STORAGE_MEDIA_PIPE = 'stateMediaPipe';

export { SESSION_STORAGE_MEDIA_PIPE };
